import type { HTMLAttributes } from 'react';

import { cn } from '@utils/cn';

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  className?: string;
};

export function Container({ children, className, ...props }: ContainerProps) {
  return (
    <div
      className={cn('mx-auto max-w-7xl', className)}
      {...props}
    >
      {children}
    </div>
  );
}
